import React from 'react';
import { Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { NdoeFilterBar } from '../../components/ndoe';

/**
 * ReportFilters — barre de filtres commune aux écrans du module Rapports.
 *
 * Filtres partagés : recherche produit, marque, catégorie, matière, couleur, pointure.
 * Les filtres SPÉCIFIQUES à un rapport (statut stock, recommandation…) se passent
 * en `children` : ils s'insèrent avant le sélecteur de tri.
 *
 * Props :
 *  - q, setQ            : terme de recherche (débattu par la page appelante)
 *  - filters, setFilter : { marque, categorie, matiere, couleur, pointure, … } / (key) => (value) => void
 *  - refs               : listes de référence (cf. useRefLists)
 *  - sort, setSort, sorts
 *  - activeCount        : nombre de filtres actifs (badge mobile)
 */
export default function ReportFilters({
  q, setQ, filters, setFilter, refs, sort, setSort, sorts = [], activeCount = 0, children,
}) {
  return (
    <NdoeFilterBar activeCount={activeCount}>
      <div className="ndoe-filter-bar__field">
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="Rechercher un produit"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      <div className="ndoe-filter-bar__field">
        <Select allowClear placeholder="Marque" style={{ minWidth: 150 }} options={refs.marques}
          value={filters.marque || undefined} onChange={setFilter('marque')} />
      </div>
      <div className="ndoe-filter-bar__field">
        <Select allowClear placeholder="Catégorie" style={{ minWidth: 150 }} options={refs.categories}
          value={filters.categorie || undefined} onChange={setFilter('categorie')} />
      </div>
      <div className="ndoe-filter-bar__field">
        <Select allowClear placeholder="Matière" style={{ minWidth: 140 }} options={refs.matieres}
          value={filters.matiere || undefined} onChange={setFilter('matiere')} />
      </div>
      <div className="ndoe-filter-bar__field">
        <Select allowClear placeholder="Couleur" style={{ minWidth: 140 }} options={refs.couleurs}
          value={filters.couleur || undefined} onChange={setFilter('couleur')} />
      </div>
      <div className="ndoe-filter-bar__field">
        <Select allowClear placeholder="Pointure" style={{ minWidth: 120 }} options={refs.pointures}
          value={filters.pointure || undefined} onChange={setFilter('pointure')} />
      </div>

      {children}

      <div className="ndoe-filter-bar__field">
        <Select style={{ minWidth: 195 }} options={sorts} value={sort} onChange={setSort} />
      </div>
    </NdoeFilterBar>
  );
}
